module.exports = __webpack_public_path__ + "assets/images/prerequisite-skill-icon.959130df9da96107f81d4f498d5e2e52.svg";